import request from '@/utils/request'

/**
 * 查询积分列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listIntegral(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/integral.listIntegral',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 修改积分数量
 * @param {Object} data 修改数据
 * @returns {Promise} Promise对象
 */
export function changeIntegralAmount(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/integral.changeIntegralAmount',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除积分账户
 * @param {Object} data 删除数据
 * @returns {Promise} Promise对象
 */
export function deleteIntegral(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/integral.deleteIntegral',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg))
      }
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}